/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    isActive: PropTypes.bool,
    title: PropTypes.string,
    innerRef: PropTypes.func.isRequired,
};

const defaultProps = {
    title: '',
};

export default class TripItineraryRowHeader extends React.Component {
    render() {
        const { title, innerRef, isActive } = this.props;
        let className = 'date';

        if (isActive) {
            className += ' active';
        }
        return (
            <h4
                ref={innerRef}
                className="trip-planner-itinerary-row-header"
                tabIndex="-1"
            >
                <span className={className}>{title}</span>
            </h4>
        );
    }
}

TripItineraryRowHeader.propTypes = propTypes;
TripItineraryRowHeader.defaultProps = defaultProps;
